import React from "react";
import { useData } from "./contexts/DataContext";
import ListingPriceComparison from "./ListingPriceComparison";

const FishPriceComparison = () => {
  const { fishData } = useData();

  return (
    <ListingPriceComparison
      listingData={fishData}
      dataType="fish"
      seoTitle="Sea What You Save - Compare Aquarium Fish Prices"
      seoDescription="Find the best deals on saltwater and freshwater aquarium fish. Compare prices across multiple stores and save money on your next fish purchase."
      seoKeywords="aquarium fish prices, saltwater fish deals, freshwater fish comparison, marine fish prices, coral prices, aquarium livestock"
      seoCanonical="/"
      headingFiltered="Your Custom Catch"
      descriptionFiltered="Here are the fish that match your selected filters. Find the best value for your aquarium!"
      headingUnfiltered="Today's Reef-Markable deals!"
      descriptionUnfiltered="These standout specimens are currently available at exceptional prices. Catch them before they swim away!"
    />
  );
};

export default FishPriceComparison;
